import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Search } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isInternal, POST_MIGRATION_OUTCOMES, PROGRAM_LABEL } from "@/lib/constants";
import { PageHeader, EmptyState } from "@/components/Primitives";
import { Input } from "@/components/ui/input";

export default function Alumni() {
  const { user } = useAuth();
  const internal = isInternal(user.role);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/alumni", { params: { q: q || undefined } }).then((r) => setItems(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div data-testid="alumni-page">
      <PageHeader eyebrow="Administrasi" title="Alumni" description="Siswa yang telah menyelesaikan seluruh proses penempatan (SAYONARA - SELESAI) setelah evaluasi & follow up pasca migran." />
      <div className="relative mb-4 max-w-sm"><Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" /><Input className="pl-9" placeholder="Cari nama / ID Yutaka" value={q} onChange={(e) => setQ(e.target.value)} data-testid="alumni-search" /></div>
      {items.length === 0 ? <EmptyState testId="alumni-empty" icon={GraduationCap} title="Belum ada alumni" description="Siswa akan muncul di sini setelah tombol SAYONARA - SELESAI ditekan pada tahap Evaluasi & Follow Up Pasca Migran." /> : (
        <div className="surface overflow-x-auto">
          <table className="w-full text-sm" data-testid="alumni-table">
            <thead className="bg-[hsl(var(--surface))]"><tr><th className="table-head">ID</th><th className="table-head">Nama</th><th className="table-head">Program</th>{internal && <th className="table-head">Vendor</th>}<th className="table-head">Perusahaan</th><th className="table-head">Hasil Pasca Migran</th><th className="table-head">Tanggal Sayonara</th></tr></thead>
            <tbody>{items.map((c) => (
              <tr key={c.id} className="row-hover" data-testid={`alumni-row-${c.yutaka_id}`}>
                <td className="table-cell font-mono text-xs">{c.yutaka_id}</td>
                <td className="table-cell"><Link to={`/candidates/${c.id}`} className="font-medium hover:underline" data-testid={`alumni-link-${c.yutaka_id}`}>{c.name}</Link></td>
                <td className="table-cell text-xs">{PROGRAM_LABEL(c.program)}</td>
                {internal && <td className="table-cell text-xs">{c.vendor_name}</td>}
                <td className="table-cell text-xs">{c.job ? `${c.job.company_name || "-"} · ${c.job.title}` : "-"}</td>
                <td className="table-cell text-xs">{POST_MIGRATION_OUTCOMES[c.post_migration_outcome] || c.post_migration_outcome || "-"}{c.post_migration_note && <p className="text-[11px] text-muted-foreground">{c.post_migration_note}</p>}</td>
                <td className="table-cell text-xs">{fmtDate(c.alumni_at)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
